import { apiFetch, post } from "./api";

export interface BatchQueueStats { succeeded: number; failed: number; processing: number; scheduled: number; enqueued: number; recurring: number; }
export interface BatchQueueItem { id: string; cron: string | null; lastExecutionUtc: string | null; nextExecutionUtc: string | null; lastJobState: string | null; lastJobId: string | null; }
export interface BatchQueueList { stats: BatchQueueStats; recurring: BatchQueueItem[]; storageAvailable: boolean; }
export interface BatchJobHistory { stateName: string; reason: string | null; createdAtUtc: string; }
export interface BatchQueueDetail { id: string; cron: string | null; lastJobId: string | null; lastJobState: string | null; lastError: string | null; history: BatchJobHistory[]; }

export const batchQueueApi = {
  list: (): Promise<BatchQueueList> => apiFetch<BatchQueueList>("/api/admin/batch-queue"),
  get: (id: string): Promise<BatchQueueDetail> => apiFetch<BatchQueueDetail>(`/api/admin/batch-queue/${encodeURIComponent(id)}`),
  runNow: (id: string): Promise<unknown> => post(`/api/admin/batch-queue/${encodeURIComponent(id)}/run-now`, {}),
  cancel: (id: string): Promise<unknown> => post(`/api/admin/batch-queue/${encodeURIComponent(id)}/cancel`, {}),
};
